import { useCallback, useContext } from 'react'
import { I18nContext } from './context'
import en from './locales/en.json'

export type TVars = Record<string, string | number>

/** Fill {name} placeholders. Unknown ones stay verbatim (e.g. the {h}/{/h}
 * emphasis markers, which callers split on themselves). */
export function formatMessage(template: string, vars?: TVars): string {
  if (!vars) return template
  return template.replace(/\{(\w+)\}/g, (m, k: string) => (vars[k] !== undefined ? String(vars[k]) : m))
}

export type MessageKey = keyof typeof en

/** t(key, vars?) — current locale's string with English fallback. */
export function useT() {
  const { dict } = useContext(I18nContext)
  return useCallback(
    (key: MessageKey | (string & {}), vars?: TVars): string => {
      const s = (dict ? dict[key] : undefined) ?? (en as Record<string, string>)[key] ?? key
      return formatMessage(s, vars)
    },
    [dict],
  )
}

export function useI18n() {
  return useContext(I18nContext)
}
